import React, {Component} from 'react'
import TableFilter from './TableFilter'

class TableFilters extends Component {
  constructor(props) {
    super(props)
    this.onChange = this.onChange.bind(this)
    this.state = {
      filter: props.filter
    }
  }

  onChange(filter) {
    this.setState({filter: filter}, () => {this.props.onFilter(this.state.filter, this.props.name)});
  }

  render() {
    return (
      this.props.items.map((filter, index) => (
       <TableFilter onChange={this.onChange} active={filter.value == this.state.filter} value={filter.value} label={filter.label} key={index}/>
      ))
    )
  }
}

TableFilters.defaultProps = {
  items: []
}

export default TableFilters
